import { useEffect, useMemo, useRef, useState } from 'react'
import { Plus } from 'phosphor-react'
import { useLocation, useNavigate } from 'react-router-dom'

import { ProjectForm } from './ProjectForm'
import { OptionMobile } from './OptionMobile'
import { Button } from '../../../../components/Button'
import { handlerType } from '../../../../enumns/handlerType'
import { type ProjectDomain } from '../../../../types/domain/project-domain'
import { useInfiniteScroll } from '../../../../hooks/useInfiniteScroll'
import { Spinner } from '../../../../components/Spinner'
import { type RequestDomain } from '../../../../types/domain/request-domain'

type Props = {
  data: ProjectDomain[] | undefined
  isLoadingProjects: boolean
  hasMoreProjects?: boolean
  isLoadingMoreProjects?: boolean
  onLoadMoreProjects: () => void
  requestId?: number
  requestData?: RequestDomain
}

export const MenuMobile = ({
  data,
  isLoadingProjects,
  hasMoreProjects,
  isLoadingMoreProjects,
  onLoadMoreProjects,
  requestId,
  requestData,
}: Props) => {
  const navigate = useNavigate()

  const projectsContainerRef = useRef<HTMLDivElement>(null)

  const [openCreateFormModal, setOpenCreateFormModal] = useState<boolean>(false)
  const [openedOnce, setOpenedOnce] = useState<boolean>(false)
  const location = useLocation()

  const closeModalHandler = () => {
    window.history.replaceState(null, location.pathname)
    setOpenedOnce(true)
    setOpenCreateFormModal(false)
  }

  const isProjectListEmpty = data?.length === 0 && isLoadingProjects

  useInfiniteScroll(projectsContainerRef, hasMoreProjects, onLoadMoreProjects)

  useEffect(() => {
    if (requestId) {
      if (requestId && requestData) {
        setOpenCreateFormModal(true)
      }
    }
  }, [requestId, requestData])

  const formatedRequestData = useMemo(() => {
    if (requestData && !openedOnce) {
      return {
        name: requestData.projectName,
        clientId: requestData.client?.id,
        requesterId: requestData.requester?.id,
        description: requestData.description,
        assetIds: requestData?.asset
          ? [{ id: requestData.asset?.id }].map((value) => ({
              id: value.id,
            }))
          : [{ id: undefined }],
        analystIds: requestData?.analyst
          ? [{ id: requestData.analyst?.id }].map((value) => ({
              id: value.id,
            }))
          : [{ id: undefined }],
      }
    } else {
      return undefined
    }
  }, [requestData, requestId, openedOnce])

  return (
    <>
      <nav>
        <div className="flex items-center gap-2 mb-6">
          <Button
            type="button"
            size="small"
            onClick={() => setOpenCreateFormModal(true)}
            className="h-auto py-3"
            fullWidth
          >
            <Plus size={16} />
            <p className="text-sm font-medium text-white ">Novo projeto</p>
          </Button>
          <Button
            type="button"
            size="small"
            onClick={() => navigate('/painel/projects/archived')}
            className="h-auto py-3"
            fullWidth
            variant="outline"
          >
            <p className="text-sm font-medium ">Projetos Arquivados</p>
          </Button>
        </div>

        <div className="flex flex-col">
          <div className="flex gap-2">
            <p className="mb-6 text-base font-medium  text-grey-800">
              Projetos:
            </p>
            {(isLoadingMoreProjects || isLoadingProjects) && (
              <Spinner size="small" />
            )}
          </div>
          {isProjectListEmpty ? (
            <div>Não há nehum projeto ativo cadastrado</div>
          ) : (
            <div
              ref={projectsContainerRef}
              className="pr-2 overflow-y-scroll max-h-96 scrollbar"
            >
              <div className="flex flex-col gap-2 ">
                {data?.map((project) => (
                  <OptionMobile
                    title={project.name}
                    id={project.id}
                    key={project.id}
                  />
                ))}
              </div>
            </div>
          )}
        </div>
      </nav>

      {/* Project Form Modal */}
      <ProjectForm
        isOpen={openCreateFormModal}
        title="Novo Projeto"
        onClose={closeModalHandler}
        type={handlerType.SAVE}
        requestData={formatedRequestData}
        requestId={requestId}
      />
    </>
  )
}
